import { css } from "@emotion/react";

// StepTab
const StepTabStyles = css({
  ".main-container": {
    position: "relative",
    ".trash-button": {
      position: "absolute",
      top: 10,
      right: 10,
      padding: 5,
      justifyContent: "center",
    },
  },
  ".side-menu": {
    "@media (max-width: 767px)": {
      width: "100%",
      height: 95,
      overflowX: "auto",
      overflowY: "hidden",
    },
  },
});

// CustomNode
const FalseHandlerStyle: React.CSSProperties = {
  left: "50%",
  transform: "translateX(50%)",
  backgroundColor: "#FF8A65",
  borderColor: "#FF8A65",
};

const TrueHandlerStyle: React.CSSProperties = {
  left: "50%",
  backgroundColor: "#AED581",
  borderColor: "#AED581",
  transform: "translateX(-150%)",
};

function CommonStyle(
  firstColor: string,
  secondColor: string,
  borderColor: string
): React.CSSProperties {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#FFFFFF",
    background: `linear-gradient(120deg, ${firstColor}, ${secondColor})`,
    borderStyle: "solid",
    borderColor: borderColor,
    borderWidth: 0,
  };
}

function ConnectionNodeStyles(
  firstColor: string,
  secondColor: string,
  borderColor: string
): React.CSSProperties {
  return {
    ...CommonStyle(firstColor, secondColor, borderColor),
    borderRadius: "50%",
    width: 80,
    minWidth: 80,
    height: 80,
  };
}

const CustomNodeStyle: React.CSSProperties = {
  ...CommonStyle("#B0BEC5", "#546E7A", "#263238"),
  borderRadius: 5,
  width: 100,
  height: 70,
};

const StartEndNodeStyle: React.CSSProperties = {
  ...CommonStyle("#FFE082", "#FFB300", "#FF6F00"),
  borderRadius: "50%",
  width: 90,
  minWidth: 90,
  height: 60,
};

const deactivatedNodeClass = css({
  "::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(256, 256, 256, 0.5)",
    filter: "blur(3px)",
  },
});

function sizeOfHandles(
  isMobile: boolean = false,
  type: "source" | "target" = "source"
): React.CSSProperties {
  let styles: React.CSSProperties = { width: 10, height: 10 };
  if (type === "source") {
    styles.bottom = -5;
  } else {
    styles.top = -5;
  }

  if (isMobile) {
    styles = {
      borderRadius: 0,
      borderColor: "transparent",
      width: 20,
      height: 20,
    };

    if (type === "source") {
      styles.bottom = -10;
    } else {
      styles.top = -10;
    }
  }

  return styles;
}

function hasBorder(isSelected: boolean) {
  return isSelected ? 1 : 0;
}

// ModalContext
const inputLabel: React.CSSProperties = {
  color: "#677788",
  fontSize: "0.75rem",
};

export {
  StepTabStyles,
  FalseHandlerStyle,
  TrueHandlerStyle,
  CustomNodeStyle,
  StartEndNodeStyle,
  deactivatedNodeClass,
  inputLabel,
  sizeOfHandles,
  hasBorder,
  ConnectionNodeStyles,
};
